export { default } from './calls-to-action.view';
